import { Component, OnInit } from '@angular/core';
import { BasePagedPage } from '../../base-paged-page';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { StorePromotionModel } from 'src/app/models/promotions/store-promotion.model';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { parseTime } from 'src/app/helpers/date-time';
import { StoreModel } from 'src/app/models/store/store.model';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-store-promotions',
    templateUrl: './store-promotions.component.html',
    styleUrls: ['./store-promotions.component.scss'],
    standalone: false
})
export class StorePromotionsComponent extends BasePagedPage<any, FormGroup> implements OnInit {

  public newPromotionForm = new FormGroup({
    name: new FormControl<string | undefined>(undefined, Validators.required),
    image: new FormControl<string | undefined>(undefined, Validators.required),
    isEnabled: new FormControl<boolean>(true),
    startDateUTC: new FormControl<NgbTimeStruct | undefined>(undefined),
    endDateUTC: new FormControl<NgbTimeStruct | undefined>(undefined),
    links: new FormControl([])
  });

  public currentFormGroup?: FormGroup;

  public stores: Array<StoreModel> = [];

  public constructor(private mApiService: ApiService,
    private mMessageService: MessageService,) {
    super();
  }

  ngOnInit(): void {
    this.getData(1);
    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<StoreModel>>('/api/admin/store/list', {
      page: 1,
      pageSize: 100000,
      search: undefined
    }).subscribe(r => {
      this.stores = r.items;
    });
  }

  public addNew() {
    this.isBusy = true;
    this.mApiService.post<StorePromotionModel, StorePromotionModel>('/api/admin/promotion', this.newPromotionForm.value as StorePromotionModel).subscribe({
      next: () => {
        this.isBusy = false;
        this.getData(1);
        this.mMessageService.addMessage({ text: 'Акция добавлена', type: this.mMessageService.types.success });
        this.newPromotionForm.patchValue({
          name: undefined,
          links: [],
          image: undefined,
          isEnabled: true,
          endDateUTC: undefined,
          startDateUTC: undefined
        })
      },
      error: () => this.isBusy = false
    })
  }

  public getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<any>, PagedResponseModel<StorePromotionModel>>('/api/admin/promotion/list', {
      page: page,
      pageSize: 1000000,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items.map(x => this.createFormGroup(x));

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }


  public savePromotion(item: FormGroup) {
    this.isBusy = true;
    this.mApiService.post(`/api/admin/promotion`, item.value).subscribe({
      next: r => {
        this.isBusy = false;
        this.mMessageService.addMessage({ text: 'Акция сохранена', type: this.mMessageService.types.success });
      },
      error: () => this.isBusy = false
    })
  }

  public removePromotion(item: FormGroup) {
    if (!confirm('Удалить акцию?')) {
      return;
    }

    this.isBusy = true;
    this.mApiService.delete(`/api/admin/promotion/${item.get('id')!.value}`).subscribe({
      next: r => {
        this.isBusy = false;
        this.getData(this.page);
        this.mMessageService.addMessage({ text: 'Акция удалена', type: this.mMessageService.types.success });
      },
      error: () => this.isBusy = false
    })
  }

  public selectFile(item: FormGroup, event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    this.isBusy = true;

    this.mApiService.formData<{ url: string }>('/api/admin/promotion/image/save', formData).subscribe({
      next: (r) => {
        item.controls['image'].setValue(r.url);
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public getNewPromoImageStyle() {
    const image = this.newPromotionForm.controls['image'].value;
    if (image) {
      return {
        'background-image': `url(/${image})`
      };
    }
    return {}
  }

  public setFormGroupListLinks(item: FormGroup) {
    this.currentFormGroup = item;
  }

  public toggleStore(id: string) {
    const array = this.currentFormGroup!.get('links')!.value as Array<string>;
    const index = array.indexOf(id);
    if (index == -1) {
      array.push(id);
    } else {
      array.splice(index, 1);
    }
  }

  public isChecked(id: string){
    if(!this.currentFormGroup){
      return;
    }

    return this.currentFormGroup!.get('links')!.value.indexOf(id) > -1;
  }

  private createFormGroup(promotion: StorePromotionModel) {
    return new FormGroup({
      id: new FormControl<string | undefined>(promotion.id),
      name: new FormControl<string | undefined>(promotion.name, Validators.required),
      image: new FormControl<string | undefined>(promotion.image, Validators.required),
      isEnabled: new FormControl<boolean>(promotion.isEnabled ?? false),
      startDateUTC: new FormControl<NgbTimeStruct | undefined>(parseTime(promotion.startDateUTC)),
      endDateUTC: new FormControl<NgbTimeStruct | undefined>(parseTime(promotion.endDateUTC)),
      links: new FormControl(promotion.links ?? [])
    });
  }
}